const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  partialData: {},
  companyRegNumber: "",
  isTransferYourBusiness: false,
  isTransferYourBusinessFromDashboard: false,
  transferYourBusinessInitiator: {},
  transferOrgAdmin: null,
  createdCompany: {},
  isUpdateHistory: true,
  dateFrom: null,
  dateTo: null,
  period: "",
  historyTransactions: [],
  activePeriodTab: null,
};

const transferYourBusinessSlice = createSlice({
  name: "transferYourBusiness",
  initialState,
  reducers: {
    setPartialData: (state, action) => {
      state.partialData = action.payload;
    },

    setVerifiedRegNumber: (state, action) => {
      state.companyRegNumber = action.payload;
    },

    setIsTransferYourBusiness: (state, action) => {
      state.isTransferYourBusiness = action.payload;
    },

    setIsTransferYourBusinessFromDashboard: (state, action) => {
      state.isTransferYourBusinessFromDashboard = action.payload;
    },

    setTransferYourBusinessInitiator: (state, action) => {
      state.transferYourBusinessInitiator = action.payload;
    },

    setTransferOrgAdmin: (state, action) => {
      state.transferOrgAdmin = action.payload;
    },

    setCreatedCompany: (state, action) => {
      state.createdCompany = action.payload;
    },

    setIsUpdateHistory: (state, action) => {
      state.isUpdateHistory = action.payload;
    },

    setARDPeriod: (state, action) => {
      state.period = action.payload.period;
      state.dateFrom = action.payload.dateFrom;
      state.dateTo = action.payload.dateTo;
    },
    setHistoryTransactions: (state, action) => {
      state.historyTransactions = action.payload;
    },
    setActivePeriodTab: (state, action) => {
      state.activePeriodTab = action.payload;
    },
  },
});

export const {
  setPartialData,
  setVerifiedRegNumber,
  setIsTransferYourBusiness,
  setIsTransferYourBusinessFromDashboard,
  setTransferYourBusinessInitiator,
  setCreatedCompany,
  setIsUpdateHistory,
  setARDPeriod,
  setHistoryTransactions,
  setActivePeriodTab,
  setTransferOrgAdmin,
} = transferYourBusinessSlice.actions;
export default transferYourBusinessSlice.reducer;
